import {
  SubscriptionFeature as SubscriptionFeatureDto,
  SubscriptionFeatureType,
} from '@content-api/api/subscription';
import * as Icons from '@ui/components/icons';
import { Typography } from '@ui/components';
import { cn } from '@ui/utils';
import { FC } from 'react';

export const SubscriptionFeature: FC<SubscriptionFeatureDto> = (props) => {
  const { icon, type, serviceName } = props;

  const Icon = Icons[icon as keyof typeof Icons] || Icons.Check;

  return (
    <div className="flex items-center gap-4">
      <Icon
        className={cn(
          'size-5 shrink-0',
          { 'text-weak': type === SubscriptionFeatureType.PRIMARY },
          { 'text-surface': type === SubscriptionFeatureType.SECONDARY },
        )}
      />
      <Typography variant="labelSmallBook" className="text-weak">
        {serviceName}
      </Typography>
    </div>
  );
};
